module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0049.jpg?v=68b72262";